import '../add-material-modal.css';

import { useTranslation } from 'react-i18next';

import TextField from '@pelckmans/elementis/components/text-field';

import { LinkUserMaterial } from '../../../../../api/user-material';
import { BasePayload } from '../api';
import BaseAddMaterialModal, { BaseAddMaterialModalBaseProps, BaseFormValues } from '../BaseAddMaterialModal';

interface Props extends BaseAddMaterialModalBaseProps {
  id: string;
  isYouTube?: boolean;
  material?: LinkUserMaterial;
}

export interface AddLinkMaterialPayload extends BasePayload {
  href: string;
}

export interface FormLinkMaterial extends BaseFormValues {
  url: string;
}

const URL_MATCHER =
  /^((https|http):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!$&'()*+,=]|:|@)|\/|\?)*)?$/i;

const FORM_ID = 'add-url-material-form';
const BASE = 'SHARED_COMPONENTS.ADD_MATERIAL_MODAL';

export default function AddLinkMaterialModal({
  id,
  tokenAccessor,
  moduleId,
  nodeId,
  studioGroup,
  onSubmit: onSubmitCallback,
  isYouTube = false,
  material,
}: Props) {
  const { t } = useTranslation();

  function mapToPayload(data: FormLinkMaterial): AddLinkMaterialPayload | null {
    if (material?.name === data.name && material?.href === data.url) return null;

    return {
      name: data.name,
      href: data.url,
      maxScore: 1,
    };
  }

  function getDefaultValues(material?: LinkUserMaterial): FormLinkMaterial {
    if (material) {
      return {
        name: material.name,
        url: material.href,
      };
    }

    return { name: '', url: '' };
  }
  return (
    <BaseAddMaterialModal
      formId={FORM_ID}
      modalId={id}
      tokenAccessor={tokenAccessor}
      defaultValues={getDefaultValues(material)}
      moduleId={moduleId}
      nodeId={nodeId}
      studioGroup={studioGroup}
      onSubmit={onSubmitCallback}
      payloadMapper={mapToPayload}
      materialId={material?.id}
    >
      {({ register, onSubmit, formState: { errors } }) => (
        <form id={FORM_ID} name={FORM_ID} onSubmit={onSubmit} className="form-fields">
          <TextField
            id="name"
            labelText={t(`${BASE}.NAME_INPUT.LABEL`)}
            autoComplete="on"
            required
            error={!!errors.name}
            errorText={errors.name?.message}
            {...register('name', {
              required: t(`${BASE}.NAME_INPUT.EMPTY`),
            })}
          />
          <TextField
            id="url"
            labelText={t(`${BASE}.URL_INPUT.LABEL${isYouTube ? '_YOUTUBE' : ''}`)}
            placeholder={t(`${BASE}.URL_INPUT.PLACEHOLDER${isYouTube ? '_YOUTUBE' : ''}`)}
            autoComplete="on"
            required
            error={!!errors.url}
            errorText={errors.url?.message}
            {...register('url', {
              required: t(`${BASE}.URL_INPUT.EMPTY`),
              pattern: {
                value: URL_MATCHER,
                message: t(`${BASE}.URL_INPUT.INVALID`),
              },
            })}
          />
        </form>
      )}
    </BaseAddMaterialModal>
  );
}
